import React, { useContext, useEffect, useState } from 'react'
import { Store } from '../../Context/Storage'
import OrderTables from '../../Components/Tables/OrderTables'

const ClosedOrders = () => {
    let { dasactive, setDasActive, getAllOrders, allorders } = useContext(Store)
  useEffect(() => {
    setDasActive('close')
    getAllOrders()
  }, [])
  let [filteredData, setFilteredData] = useState()
  useEffect(() => {
    if (allorders) {
      setFilteredData(allorders.filter((obj) =>obj.status=='close'))
    }
  }, [allorders])
  return (
    <div className=' ' >
      <h4 className='poppins text-slate-800 text-lg' >Open Orders  </h4>

      <OrderTables data={filteredData} />
    </div>
  )
}

export default ClosedOrders